export default "__VITE_ASSET__CgHmlG46__"